<template>
	<div>
		<label v-if="!fileInfo.fileUploaded">
			<v-btn @click="$refs.file.click()" class="ma-2">
				{{'Wybierz plik'}}
			</v-btn>
			<input :disabled="disabled" v-show=false type="file" ref="file" id="fileInput"
				:accept="acceptedFiles"
				v-on:change="handleFileUpload">
		</label>
		{{fileInfo.fileName}}
		<v-btn class="ml-3 mr-3" @click="downloadFile" v-if="fileInfo.fileUploaded">
			Pobierz
		</v-btn>
		<v-btn color="lightred" @click="deleteFile" v-if="fileInfo.fileUploaded && !disabled">
			Usuń
		</v-btn>
		<v-btn class="ml-4" @click="download" v-if="!disabled && schema.link">
			Pobierz wzór
		</v-btn>
	</div>
</template>

<script>
	import {Api} from "../../../../api";
	import {abstractField} from "vue-form-generator";
	import {Files} from "../../../../utils/Files";


	export default {
		name: "CustomAttachment",

		mixins: [abstractField, Files],

		data() {
			return {
				fileInfo: {
					fileName: "",
					fileUploaded: false,
				},
			};
		},

		created() {
			if (this.value) {
				Api.get(this, "/file/uploaded-file-info?fileHash=" + this.value, response => {
					this.fileInfo.fileUploaded = true;
					this.fileInfo.fileName = response.fileName;
				});
			}
		},

		methods: {
			download() {
        let schemaLink = this.schema.link.trim();
				if (schemaLink.startsWith(process.env.VUE_APP_API_URL)) {
					this.downloadFileAsBlob(this, schemaLink, "wzor");
				} else window.location = schemaLink;
			},

			deleteFile() {
				this.fileInfo.fileName = "";
				this.fileInfo.fileUploaded = false;
				this.value = null;
			},

			async handleFileUpload() {
				if (this.hasIncorrectFilesExtension(this.$refs.file.files)) {
					Files.methods.clearFileInput('fileInput');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
					return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.file.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput('fileInput');
					return;
				}
				let file = this.$refs.file.files[0];
				let formData = new FormData();
				formData.append("file", file);
				this.$http.post(process.env.VUE_APP_API_URL + "/file/upload-file", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}).then(successResponse => {
						this.fileInfo.fileUploaded = true;
						this.value = successResponse.body.fileHash;
						this.fileInfo.fileName = successResponse.body.fileName;
					},
            errorResponse => {
              let errorMessage = errorResponse.status === 429
                  ? "Wystąpił błąd podczas załączenia pliku: wykorzystano limit żądań. Odczekaj kilka minut zanim spróbujesz ponownie"
                  : "Nie udało się wgrać pliku, jeśli problem się powtarza, skontaktuj się z administratorem";
						this.$messagesBus.$emit("error", errorMessage);
					});
			},

			downloadFile () {
				this.downloadFileAsBlob(this, this.getFileUrl(this.value), this.fileInfo.fileName);
			}
		},
	};
</script>

<style scoped>
	.vue-form-generator .field-wrap button {
		border: none;
	}
</style>
